import { ErrorTypes, ErrorsResJsonTypes } from 'types/app';

const SOURCE_POINTER_REGEXP = /^\/?data\/(attributes|relationships)\/(.*)/;
const BASE_KEY = 'base';

const errorParser = (resJson: ErrorsResJsonTypes) => {
  const result: ErrorTypes = {};

  resJson.errors.forEach((error) => {
    if (error.source && error.source.pointer) {
      const matches = error.source.pointer.match(SOURCE_POINTER_REGEXP);
      if (!matches) return;

      const key = matches.pop();
      if (!key) return;

      if (!result[key]) result[key] = [];
      result[key].push(error.detail[0]);
    } else if (error.title) {
      const key = BASE_KEY;

      if (!result[key]) result[key] = [];
      result[key].push(error.title);
    }
  });

  return result;
};

export default errorParser;
